// extracted by mini-css-extract-plugin
export var addToCartButton = "_k4-b";
export var arrowButtonContainer = "_k4-9";
export var arrowButtonIcon = "_k4-a";
export var carouselArrowButton = "_k4-6";
export var carouselElementContainer = "_k4-1";
export var left = "_k4-7";
export var productDisplayCarouselContainer = "_k4-0";
export var productTileContainer = "_k4-2";
export var productTileImage = "_k4-4";
export var productTileImageContainer = "_k4-3";
export var productTileTitle = "_k4-5";
export var right = "_k4-8";
export var sliderOverflow = "_k4-c";